'use client'

import { Box, Text, Flex, Button, Image } from '@chakra-ui/react'
import { BottomNav } from '@/components/ui/bottom-nav'
import Link from 'next/link'

export default function GuestView() {
  return (
    <Box pb={10} px={[4, 4, 4, 4]}>
      <Flex
        height={'70vh'}
        justifyContent={'center'}
        alignItems={'center'}
        flexDir={'column'}
      >
        <Image
          mb={5}
          src="/guest/subscriptions.svg"
          alt="Rewards"
          boxSize={100}
        />
        <Text fontSize={[24, 24, 32]} fontWeight={600} textAlign={'center'}>
          Follow your favorite creators
        </Text>
        <Text
          fontSize={[15, 15, 20]}
          fontWeight={500}
          color={'#7a7a7a'}
          textAlign={'center'}
        >
          Sign in to start subscribing to creators
        </Text>

        <Flex gap={5} mt={8}>
          <Button
            width={200}
            size={'md'}
            bg={'lyk-green'}
            color={'white'}
            as={Link}
            href="/auth/login"
          >
            Sign In
          </Button>
        </Flex>
      </Flex>

      <BottomNav />
    </Box>
  )
}
